var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFishDead(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.271,
    height: 26.85,
    viewBox: "0 0 53.271 26.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.271,
    height: 26.85,
    fill: "#004878"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.971,45c-.263-.489-.512-.895-.706-1.326a9.1,9.1,0,0,1,.209-7.48,10.117,10.117,0,0,1,5.58-5.805c-.034-.05-.051-.095-.065-.094a54.208,54.208,0,0,0-9.169,1.173,22.369,22.369,0,0,0-9.664,5.295c-1.269,1.15-2.42,2.43-3.621,3.656a1.308,1.308,0,0,0-.275.448,10.662,10.662,0,0,1,10.5-.493A45.333,45.333,0,0,1,154.971,45",
    transform: "translate(-121.07 -27.138)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.024,50.969c1.454-.135,3.285-.282,5.109-.487a7.309,7.309,0,0,0,1.6-.442,1.151,1.151,0,0,0,.807-1.253,6.084,6.084,0,0,0-.911-2.632,27.115,27.115,0,0,0-7.845-8.912,11.05,11.05,0,0,0-1.12-.656,1.439,1.439,0,0,0-1.934.306,15.5,15.5,0,0,0-1.833,2.44A13.162,13.162,0,0,0,.022,46.744a6.4,6.4,0,0,0,.242,1.432,3.388,3.388,0,0,0,3.271,2.518c1.365.108,2.734.17,4.489.276M7.2,48.462a3.267,3.267,0,1,1,.058-6.524A3.266,3.266,0,1,1,7.2,48.462m6.438-.314c.561.22.729.526.4.918l-.4-.918",
    transform: "translate(37.731 -32.563)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.353,144.618c3.786,2.759,7.526,5.611,12.4,6.183a11.847,11.847,0,0,0-1.521,5.509,6.079,6.079,0,0,1,3.446-3.693c-.392-.308-.906-.533-1.114-.923a4.321,4.321,0,0,1-.209-1.483l.159-.017.051.733h4.981l.074-.169a9.916,9.916,0,0,1-4.054-4.553,1.654,1.654,0,0,0-.166.287,2.629,2.629,0,0,1-2.516,2.046,11.718,11.718,0,0,1-6.684-1.355c-1.545-.778-3.025-1.688-4.534-2.539l-.256-.142-.057.116",
    transform: "translate(-153.081 -129.461)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.821,177.544c-.216.017-.434.016-.646.053a29.665,29.665,0,0,1-8.127.454c-.948-.1-1.892-.229-2.838-.353-.885-.116-1.175.136-1.173,1.036,0,.1,0,.208.007.312.06,1.757.544,2.285,2.422,2.419a11.025,11.025,0,0,0,5.084-1.127c1.593-.677,3.138-1.466,4.7-2.218a5.077,5.077,0,0,0,.631-.426l-.059-.151",
    transform: "translate(26.033 -159.064)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.188,53.576a4.165,4.165,0,0,1-.159-4.437c-.1-.069-.165-.123-.238-.169a4.275,4.275,0,0,1-1.915-4.65A16.414,16.414,0,0,1,130.307,35l-.062-.123a15.2,15.2,0,0,0-2.047,1.3,11.978,11.978,0,0,0-4.178,7.905c-.244,2.224.329,4.142,2.372,5.373.3.179.268.4.224.662a3.154,3.154,0,0,0,.357,2.312,15.662,15.662,0,0,0,1.008,1.268l.206-.119",
    transform: "translate(-89.94 -31.246)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.289,133.514c1.918-1.071,3.605-2.279,4.224-4.486-.98-.619-3.274-.311-4.467.6l1.918-.16.061.194c-.935.42-1.865.851-2.806,1.256a4.4,4.4,0,0,0-2.389,1.563c-.4.694-.711,1.443-1.062,2.167l.139.074c.257-.339.514-.678.772-1.016a4.147,4.147,0,0,1,3.6-1.489c.317,0,.4.143.29.431-.1.272-.182.551-.284.863",
    transform: "translate(-427.769 -115.308)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.308,62.732c-.19-2.281-1.621-3.783-3.312-5.2.045.309.071.586.128.856.08.378-.063.456-.417.4a4.188,4.188,0,0,1-3.463-2.57c-.047-.112-.105-.218-.157-.328a.666.666,0,0,0-.162-.246,4.34,4.34,0,0,0,1.712,3.686c1.078.722,2.123,1.494,3.181,2.246.067.047.122.111.3.277l-2.012-.526a4.86,4.86,0,0,0,4.2,1.414",
    transform: "translate(-424.372 -49.846)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.208,110.95a13.8,13.8,0,0,1,4.487,3.354c-.134-.241-.266-.483-.4-.722-.363-.631-.71-1.273-1.1-1.888a1.376,1.376,0,0,1-.007-1.569c.33-.525.73-1.005,1.119-1.531l-4.111,2.207.015.15",
    transform: "translate(-337.876 -97.29)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.735,111.322l-3.639,1.947a12.9,12.9,0,0,1,3.88,2.783c-.078-.148-.152-.3-.235-.444-.3-.526-.582-1.066-.916-1.57a1.246,1.246,0,0,1,.011-1.5c.266-.4.568-.771.9-1.215",
    transform: "translate(-376.895 -99.735)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.489,2.938c.474-.857,1.086-.607,1.707-.341A5.949,5.949,0,0,0,160.115,0a4.36,4.36,0,0,1,1.374,2.937",
    transform: "translate(-126.592 -0.001)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.54,15.3a4.88,4.88,0,0,0-2.04-1.81l.887,1.92c.257-.387.683-.356,1.154-.11",
    transform: "translate(-166.828 -12.085)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.044,25.908l.549,1.217.9-.167L227.1,25.825l-.053.083",
    transform: "translate(-198.854 -23.137)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.021,38.811l.6-.289-1.075-.568-.042.078.515.779",
    transform: "translate(-222.22 -34.003)",
    fill: "#004878"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishDead);
export default __webpack_public_path__ + "static/media/fishDead.bf2eae3d5680cacd4b876fa4a4a943d0.svg";
export { ForwardRef as ReactComponent };